const SECTION_VALIDATION_ERROR_MESSAGE =
  "Quality check could not process one or more suggestions for this section. The remaining findings are still available below.";

export const getFriendlyQCErrorMessage = (
  message?: string | null,
): string => {
  if (!message) return SECTION_VALIDATION_ERROR_MESSAGE;

  const lowerMessage = message.toLowerCase();
  const exposesInternalValidation =
    lowerMessage.includes("malformed finding") ||
    lowerMessage.includes("finding_type=") ||
    lowerMessage.includes("severity=");

  return exposesInternalValidation ? SECTION_VALIDATION_ERROR_MESSAGE : message;
};
